import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { CaretLeft } from '@phosphor-icons/react';
import clsx from 'clsx';
import { Breadcrumb, Breadcrumbs } from '@la/shared-components';
import styles from './PageTitle.module.scss';

export type PageTitleProps = {
  breadcrumbs?: Breadcrumb[];
  showBackButton?: boolean;
  backButtonPath?: string;
};

/* PageTitle */
export default function PageTitle({
  breadcrumbs = [],
  children,
  showBackButton = false,
  backButtonPath,
}: PropsWithChildren<PageTitleProps>) {
  const navigate = useNavigate();
  const hasBreadcrumbs = breadcrumbs?.length > 0;

  const pageTitleClassName = clsx(
    styles.pageTitle,
    hasBreadcrumbs && styles.withBreadcrumbs
  );

  return (
    <div className={pageTitleClassName}>
      {hasBreadcrumbs ? (
        <div className={styles.breadcrumbs}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      ) : null}
      {showBackButton ? (
        <button
          className={styles.backButton}
          aria-label="Back"
          onClick={() => {
            if (backButtonPath) {
              navigate(backButtonPath);
            } else {
              navigate(-1);
            }
          }}
        >
          <CaretLeft fill="white" weight="bold" />
        </button>
      ) : null}
      {children}
    </div>
  );
}
/* */
